<input
  [value]="textInput() ?? (value() | format: format())"
  (input)="onTextInput(inputElement.value)"
  (change)="onValueChange(inputElement.value)"
  #inputElement
  (dblclick)="!readonly() ? openDateRangePickerModal() : ''"
  (blur)="blur.emit()"
  [readOnly]="readonly()"
  placeholder="{{ placeholder() | translate}}"
  />
@if (!readonly()) {
  <i
    class="fa-regular fa-calendar-range picker-icon pointer ml-4"
    (click)="openDateRangePickerModal()"
  ></i>
}
